/**
 * پل نرم‌افزار ویندوز
 * ====================
 * سایت و نرم‌افزار دسکتاپ یک کد دارند؛ این فایل تنها جایی است که تفاوتشان
 * را می‌داند.
 *
 * وقتی صفحه داخل نرم‌افزار ویندوز اجرا شود، پوسته‌ی Tauri یک شیء به نام
 * `__TAURI__` روی `window` می‌گذارد. از روی آن می‌شود قابلیت‌هایی را فعال
 * کرد که فقط آنجا معنا دارند.
 *
 * ── چرا هشدارها از اینجا فرستاده می‌شوند ─────────────────────────────────
 * هشدارهای قیمت به حساب کاربر گره خورده‌اند و خواندنشان از سرور توکن ورود
 * می‌خواهد. آن توکن در حافظه‌ی همین صفحه است؛ فرستادنش به سمت Rust یعنی
 * نگه‌داشتن نسخه‌ای دیگر از کلید ورود در جای دیگر — ریسکی که ارزشش را
 * ندارد.
 *
 * به‌جایش، صفحه که **از قبل وارد شده** فهرست را می‌خواند و همان را به
 * نرم‌افزار می‌دهد. نرم‌افزار فقط قیمت‌ها را می‌پاید و وقتی هدفی رد شد اعلان
 * ویندوز نشان می‌دهد — رایگان و فوری، به‌جای پیامکی که برای صرافی هزینه
 * دارد.
 *
 * همه چیز اینجا **دفاعی** نوشته شده: اگر پل نبود، نسخه‌ی قدیمی نرم‌افزار
 * بود، یا فرمانی وجود نداشت، هیچ‌کدام نباید صفحه را بشکنند. سایت باید در
 * مرورگر معمولی دقیقاً مثل قبل کار کند.
 */

type Invoke = (cmd: string, args?: Record<string, unknown>) => Promise<unknown>

function invoker(): Invoke | null {
  if (typeof window === 'undefined') return null
  const t = (window as any).__TAURI__
  const fn = t?.core?.invoke ?? t?.invoke
  return typeof fn === 'function' ? fn.bind(t?.core ?? t) : null
}

/** آیا این صفحه داخل نرم‌افزار ویندوز ارزینو باز شده است؟ */
export const isDesktopApp = (): boolean => invoker() !== null

/** شکل هشداری که نرم‌افزار می‌فهمد. */
export type DesktopAlert = {
  id: number
  symbol: string
  /** `above` یا `below` */
  direction: string
  target: number
}

/**
 * فرستادن فهرست هشدارها به نرم‌افزار.
 *
 * فهرست **جایگزین** می‌شود، نه اضافه: اگر کاربر هشداری را در سایت پاک کند،
 * باید در نرم‌افزار هم پاک شود. حالت «قبلاً اعلام‌شده» را خود نرم‌افزار
 * نگه می‌دارد، پس این فراخوانی هشدارهای گذشته را دوباره شلیک نمی‌کند.
 *
 * خروجی: تعداد هشدار ثبت‌شده، یا `null` وقتی در نرم‌افزار نیستیم.
 */
export async function syncAlerts(alerts: DesktopAlert[]): Promise<number | null> {
  const invoke = invoker()
  if (!invoke) return null
  try {
    const n = await invoke('alerts_sync', {
      alerts: alerts.map((a) => ({
        id: Number(a.id),
        symbol: String(a.symbol || '').toUpperCase(),
        direction: a.direction === 'below' ? 'below' : 'above',
        target: Number(a.target) || 0,
      })),
    })
    return typeof n === 'number' ? n : null
  } catch {
    // نسخه‌ی قدیمی نرم‌افزار این فرمان را ندارد — سایت باید عادی کار کند
    return null
  }
}
